import { loadStripe, Stripe } from "@stripe/stripe-js";

// Singleton wrapper around loadStripe — Stripe.js must only be initialised
// once per page load. Reads REACT_APP_STRIPE_PUBLISHABLE_KEY lazily at first
// call and throws explicitly when missing so the failure surfaces at the
// <Elements/> mount instead of producing a confusing Stripe.js error.

let stripePromise: Promise<Stripe | null> | null = null;

export const getStripePromise = (): Promise<Stripe | null> => {
  if (stripePromise !== null) {
    return stripePromise;
  }
  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  if (!publishableKey) {
    throw new Error(
      "REACT_APP_STRIPE_PUBLISHABLE_KEY is not set. Add it to .env and restart the dev server."
    );
  }
  stripePromise = loadStripe(publishableKey);
  return stripePromise;
};
